export default __webpack_public_path__ + "static/media/logotype.97bdb507.svg";